const IOS_STORE_URL =
  "https://apps.apple.com/us/app/emblem-digital-souvenirs/id6463515811";
const ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.emblemstartup.luxembourg";

const DEFAULT_UTM = {
  source: "website",
  medium: "organic",
  campaign: "emblem_web",
};

const IOS_MATCH = "apps.apple.com/us/app/emblem-digital-souvenirs/id6463515811";
const ANDROID_MATCH =
  "play.google.com/store/apps/details?id=com.emblemstartup.luxembourg";

const sanitizePathForContent = (pathname = "/") => {
  if (!pathname || pathname === "/") {
    return "home";
  }

  return pathname
    .replace(/^\//, "")
    .replace(/[^\w/-]+/g, "")
    .replace(/\//g, "_")
    .toLowerCase();
};

export const appendUtmParams = (url, params = {}) => {
  try {
    const parsed = new URL(url);
    const merged = {
      ...DEFAULT_UTM,
      ...params,
    };

    if (merged.source) {
      parsed.searchParams.set("utm_source", merged.source);
    }
    if (merged.medium) {
      parsed.searchParams.set("utm_medium", merged.medium);
    }
    if (merged.campaign) {
      parsed.searchParams.set("utm_campaign", merged.campaign);
    }
    if (merged.content) {
      parsed.searchParams.set("utm_content", merged.content);
    }
    if (merged.term) {
      parsed.searchParams.set("utm_term", merged.term);
    }

    return parsed.toString();
  } catch (error) {
    return url;
  }
};

export const getStorePlatformFromUrl = (url = "") => {
  if (url.includes(IOS_MATCH)) {
    return "ios";
  }
  if (url.includes(ANDROID_MATCH)) {
    return "android";
  }
  return null;
};

export const isStoreLink = (url = "") => {
  return Boolean(getStorePlatformFromUrl(url));
};

export const getStoreUrl = (platform, context = {}) => {
  const baseUrl = platform === "android" ? ANDROID_STORE_URL : IOS_STORE_URL;
  const fallbackPathname = typeof window !== "undefined" ? window.location.pathname : "/";
  const content = context.content ||
    sanitizePathForContent(context.pathname || fallbackPathname);

  return appendUtmParams(baseUrl, {
    source: context.source || DEFAULT_UTM.source,
    medium: context.medium || DEFAULT_UTM.medium,
    campaign: context.campaign || DEFAULT_UTM.campaign,
    content,
    term: context.term,
  });
};

export const detectDevicePlatform = () => {
  if (typeof navigator === "undefined") {
    return "web";
  }

  const ua = navigator.userAgent || "";
  const hasMsStream = typeof window !== "undefined" && window.MSStream;

  if (/android/i.test(ua)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(ua) && !hasMsStream) {
    return "ios";
  }

  return "web";
};

export const getSmartStoreUrl = (context = {}) => {
  const platform = detectDevicePlatform();
  if (platform === "android") {
    return getStoreUrl("android", context);
  }
  return getStoreUrl("ios", context);
};

export const decorateStoreLinks = (pathname = "/") => {
  if (typeof document === "undefined") {
    return;
  }

  const anchors = document.querySelectorAll("a[href]");
  anchors.forEach((anchor) => {
    const href = anchor.getAttribute("href") || "";
    const platform = getStorePlatformFromUrl(href);

    if (!platform) {
      return;
    }

    const attributedHref = getStoreUrl(platform, {
      pathname,
      medium: anchor.dataset.utmMedium || "website",
      campaign: anchor.dataset.utmCampaign || DEFAULT_UTM.campaign,
      content: anchor.dataset.utmContent ||
        sanitizePathForContent(`${pathname}_${platform}`),
    });

    if (href !== attributedHref) {
      anchor.setAttribute("href", attributedHref);
    }
  });
};
